import FpArchitectEditor from './FpArchitectEditor'
import FpArchitectMenuEditor from './FpArchitectMenuEditor'
import FpArchitectServer from './FpArchitectServer'
import FpArchitectApi from './FpArchitectApi'

export { FpArchitectEditor, FpArchitectMenuEditor, FpArchitectServer, FpArchitectApi }

export default { FpArchitectEditor, FpArchitectMenuEditor, FpArchitectServer, FpArchitectApi }
